export default __webpack_public_path__ + "53486705bb18fb5f1b5123c9bb35efec.png";